import React from 'react'

export const ChatImageIcon = ({
  size = 30,
  className,
  opacity = 1,
}: {
  color?: string
  size?: number
  className?: string
  opacity?: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      className={className}
      fill="none"
      opacity={opacity}
    >
      <g>
        <path
          d="M15 7.24902C15.4141 7.24902 15.7498 7.58496 15.75 7.99902C15.75 8.41324 15.4142 8.74902 15 8.74902H12C10.2052 8.74902 8.75017 10.2042 8.75 11.999V15.958C9.1784 16.3624 9.66751 16.7142 10.1416 16.9697C10.6772 17.2583 11.1516 17.4033 11.4756 17.4033C12.1671 17.4033 13.006 17.0097 14.0059 16.0479L14.0146 16.0391L14.248 15.8359C15.4187 14.8508 16.661 14.3451 17.9512 14.3711C19.0636 14.3936 20.1676 14.8109 21.25 15.583V14.3193C21.2502 13.9053 21.5859 13.5693 22 13.5693C22.4141 13.5693 22.7498 13.9053 22.75 14.3193V17.999C22.75 20.6224 20.6234 22.749 18 22.749H12C9.37665 22.749 7.25 20.6224 7.25 17.999V11.999C7.25017 9.37582 9.37676 7.24902 12 7.24902H15ZM18.0547 16.0684C17.0593 16.0055 16.1051 16.3842 15.1357 17.2598L15.1348 17.2588C13.9353 18.4105 12.7157 19.0605 11.4756 19.0605C10.6171 19.0605 9.6472 18.6954 8.75195 18.0889C8.79939 19.8424 10.235 21.249 12 21.249H18C19.7949 21.249 21.25 19.7939 21.25 17.999V17.5439C20.0554 16.5928 19.004 16.1284 18.0547 16.0684ZM12.4629 10.5127C13.5674 10.5127 14.4627 11.4083 14.4629 12.5127C14.4629 13.6173 13.5675 14.5127 12.4629 14.5127C11.3583 14.5127 10.4629 13.6173 10.4629 12.5127C10.4631 11.4083 11.3584 10.5127 12.4629 10.5127ZM12.4629 12.0127C12.1869 12.0127 11.9631 12.2367 11.9629 12.5127C11.9629 12.7888 12.1867 13.0127 12.4629 13.0127C12.739 13.0127 12.9629 12.7888 12.9629 12.5127C12.9627 12.2367 12.7389 12.0127 12.4629 12.0127ZM19.9873 7.31641C20.045 7.19156 20.2216 7.19156 20.2793 7.31641L21.0146 8.90723C21.0307 8.94185 21.0591 8.96933 21.0938 8.98535L22.6846 9.7207C22.8089 9.77857 22.809 9.95589 22.6846 10.0137L21.0938 10.748C21.059 10.7641 21.0307 10.7924 21.0146 10.8271L20.2793 12.418C20.2215 12.5424 20.0451 12.5424 19.9873 12.418L19.252 10.8271C19.2359 10.7924 19.2076 10.7641 19.1729 10.748L17.582 10.0137C17.4576 9.95589 17.4577 9.77857 17.582 9.7207L19.1729 8.98535C19.2075 8.96933 19.2359 8.94185 19.252 8.90723L19.9873 7.31641Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default ChatImageIcon
